import React from 'react'
import { FrontPage } from 'cvs-core'
import menuLogo from '../../assets/images/Vape-Free-Reverse-Text-Red-X Copy@2x.jpg'
import backgroundImg from '../../assets/images/U2-T1-0-0a.svg'
import foregroundImg from '../../assets/images/U2-T1-0-0b.svg'

const data = {
  title: 'Empowering Yourself and Others to Be Vape Free',
  subTitle: '',
  intro: (
    <p>
      Students will learn how to empower themselves and others to stay vape
      free. They will learn how to be effective advocates for themselves and
      others.
    </p>
  ),
  logo: menuLogo,
  foregroundImg,
  backgroundImg,
}

export default {
  title: 'Welcome',
  path: '/',
  content: <FrontPage data={data} />,
}



// WEBPACK FOOTER //
// ./src/data/home/index.js